import { render } from "./NotificationIcon.vue?vue&type=template&id=39d83234&scoped=true&ts=true"
import script from "./NotificationIcon.vue?vue&type=script&lang=ts"
export * from "./NotificationIcon.vue?vue&type=script&lang=ts"

import "./NotificationIcon.vue?vue&type=style&index=0&id=39d83234&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d83234"],['__file',"src/components/NotificationIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "39d83234"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('39d83234', __exports__)) {
    api.reload('39d83234', __exports__)
  }
  
  module.hot.accept("./NotificationIcon.vue?vue&type=template&id=39d83234&scoped=true&ts=true", () => {
    api.rerender('39d83234', render)
  })

}


export default __exports__